<div
  class="group relative px-2 py-1.5 text-sm transition-all duration-150"
  [ngClass]="{
    'rounded-md': rounded === 'md',
    'rounded-lg': rounded === 'lg',
    'bg-base-200': isRecipe,
    'bg-warning/15 ring-1 ring-inset ring-warning/30': isFreeText,
    'bg-secondary/10': isLeftover,
    'border border-error': entry.failed,
    'opacity-60': entry.pending,
    'cursor-pointer': isNavigable,
    'hover:bg-warning/25': isFreeText && !entry.pending && !entry.failed,
    'hover:shadow-md motion-safe:hover:-translate-y-px': !entry.pending && !entry.failed
  }"
  (click)="onBodyClick()"
  [attr.role]="isNavigable ? 'button' : null"
  [attr.tabindex]="isNavigable ? 0 : null"
  (keydown.enter)="onBodyClick()"
>
  <!-- Leftover chip -->
  @if (isLeftover) {
    <div class="flex items-center gap-1.5 text-secondary">
      <fa-icon [icon]="faUtensils" class="text-xs opacity-70"></fa-icon>
      <span class="truncate font-medium">{{ entry.title }}</span>
    </div>
  } @else {
    <!-- Title gets the full row; actions overlay the top-right on hover so they
         never consume title width (critical in narrow grid cells). -->
    <div class="flex min-w-0 items-center gap-1 pr-1">
      <span class="truncate font-medium" [class.text-base-content]="isRecipe" [class.text-base-content]="true"
            [class.italic]="isFreeText" [class.opacity-70]="isFreeText">
        {{ entry.title }}
      </span>
      @if (sourceLabel) {
        <span
          class="badge badge-xs shrink-0"
          [class.badge-secondary]="entry.source === 'assistant'"
          [class.badge-ghost]="entry.source === 'system'"
        >{{ sourceLabel }}</span>
      }
    </div>

    <!-- Actions: only for persisted, non-pending entries. Absolutely positioned
         and pointer-events-none while hidden so they don't intercept body clicks. -->
    @if (!entry.pending && !entry.failed) {
      <div class="pointer-events-none absolute right-1 top-1 flex shrink-0 items-center gap-0.5 rounded-md bg-base-100/80 opacity-0 shadow-sm backdrop-blur-sm transition-opacity group-hover:pointer-events-auto group-hover:opacity-100 focus-within:pointer-events-auto focus-within:opacity-100">
        <button type="button" class="btn btn-ghost btn-xs btn-square" aria-label="Bearbeiten"
                (click)="$event.stopPropagation(); edit.emit(entry)">
          <fa-icon [icon]="faPen" class="text-xs"></fa-icon>
        </button>
        <button type="button" class="btn btn-ghost btn-xs btn-square text-error" aria-label="Löschen"
                (click)="$event.stopPropagation(); remove.emit(entry)">
          <fa-icon [icon]="faTrash" class="text-xs"></fa-icon>
        </button>
      </div>
    }

    <!-- Meta row: time · servings (with ×N when overridden) -->
    @if (isRecipe && (totalMinutes || entry.servings != null)) {
      <div class="mt-0.5 flex items-center gap-2 text-xs text-base-content/60">
        @if (totalMinutes) {
          <span class="flex items-center gap-1"><fa-icon [icon]="faClock"></fa-icon>{{ totalMinutes }} Min</span>
        }
        @if (entry.servings != null) {
          <span>
            {{ entry.servings }} Port.
            @if (servingsMultiplier) {
              <span class="badge badge-ghost badge-xs align-middle">×{{ servingsMultiplier }}</span>
            }
          </span>
        }
      </div>
    }

    @if (entry.note) {
      <div class="mt-0.5 truncate text-xs text-base-content/50 italic">{{ entry.note }}</div>
    }

    <!-- Turn a free-text proposal into a real recipe via the assistant. This is
         the primary intent for a proposal card, so it's a full-width, always-
         visible button rather than a hover-only icon. -->
    @if (isFreeText && showCreateRecipe && !entry.pending && !entry.failed) {
      <button type="button"
              class="btn btn-secondary btn-soft btn-sm mt-2 w-full gap-1.5"
              (click)="$event.stopPropagation(); createRecipe.emit(entry)">
        <fa-icon [icon]="faWandMagicSparkles" class="text-xs"></fa-icon>
        Rezept erstellen
      </button>
    }
  }

  <!-- Pending / failed indicators -->
  @if (entry.pending) {
    <span class="loading loading-spinner loading-xs absolute right-1.5 top-1.5 text-base-content/40"></span>
  }
  @if (entry.failed) {
    <div class="mt-1 flex items-center gap-1">
      <span class="text-xs text-error">Fehlgeschlagen</span>
      <button type="button" class="btn btn-ghost btn-xs btn-square text-error" aria-label="Erneut versuchen"
              (click)="$event.stopPropagation(); retry.emit(entry)">
        <fa-icon [icon]="faRotateRight" class="text-xs"></fa-icon>
      </button>
      <button type="button" class="btn btn-ghost btn-xs btn-square" aria-label="Verwerfen"
              (click)="$event.stopPropagation(); remove.emit(entry)">
        <fa-icon [icon]="faXmark" class="text-xs"></fa-icon>
      </button>
    </div>
  }
</div>
